import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {ViewEncapsulation} from '@angular/core';
import {DataTableDirective} from "angular-datatables";
import * as _ from "lodash";

declare var $: any;
declare var jQuery: any;
declare var moment: any;

@Component({
    selector: 'lls-datagrid',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './datagrid.component.html',
    styleUrls: ['./datagrid.component.scss']
})

export class DatagridComponent implements OnInit, AfterViewInit {
    @Input() options: any = {};
    @Output() gridInit: EventEmitter<any> = new EventEmitter();
    @Output() rowsSelected: EventEmitter<any> = new EventEmitter();
    dtOptions: any = {};
    dtInstance: any;

    @ViewChild(DataTableDirective, { static: true })
    private datatableElement: any;
    private checkboxCol: any;

    constructor() {

    }

    ngOnInit() {
        this.options = _.cloneDeep(this.options);
        // Use Object.assign to define some defaults for data table configs, which can be
        // overridden by the "options" input. Use the list below to change default datagrid configs
        // throughout the application.
		// NOTE: the '[style*="display: none"]' selector is used for export when a column to be rendered gets treated as a child by the responsive plugin
        this.dtOptions = Object.assign({
            lengthChange: false,
            pageLength: 10,
            responsive: true,
            dom: 'Bfrtip',
            language: {
                'paginate': {
                    'previous': '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                    'next': '<i class="fa fa-angle-right" aria-hidden="true"></i>'
                }
            },
            buttons: [{
                extend: 'colvis',
                className: 'btn btn-sm btn-outline-primary',
                text: '' + '<i title="Choose Columns" class="fa fa-cog"></i>',
                tag: 'a'
            },{
                extend: 'collection',
                text: 'Export',
                className: 'btn-primary btn btn-sm',
                autoClose: true,
                background: false,
                buttons: [
                  {
                      extend: 'excelHtml5',
                      text: 'Export as Excel',
                      className: 'dropdown-item',
                      exportOptions: {
                          columns: ':visible:not(.excludeExport), [style*="display: none"]'
                      },
                      tag: 'a'
                  }, {
                      extend: 'csvHtml5',
                      text: 'Export as CSV',
                      className: 'dropdown-item',
                      exportOptions: {
                          columns: ':visible:not(.excludeExport), [style*="display: none"]'
                      },
                      tag: 'a'
                  }
                ]
            }]
        }, this.options);

        if (this.dtOptions.addButtons) {
          let extraBtns = this.dtOptions.addButtons;
          delete this.dtOptions.addButtons;
          this.dtOptions.buttons.push(...extraBtns);
        }

        if (this.dtOptions.rowExpand) {
            this.dtOptions.columns.push({
                title: this.dtOptions.rowExpand.columnName,
                responsivePriority: this.dtOptions.rowExpand.responsivePriority,
                render: () => {
                    return '<a href class="expand-row">' + this.dtOptions.rowExpand.buttonName + '</a>';
                },
                class: 'excludeExport'
            });
        }
        if (this.dtOptions.columns) {
            for (var i = 0; i < this.dtOptions.columns.length; i++) {
                var col = this.dtOptions.columns[i];
                if (col.type == "checkbox") {
                    this.checkboxCol = col;
                    this.initCheckboxes();
                    this.checkboxCol.orderable = false;
                    this.checkboxCol.title = '<label style="min-height: 15px; margin: 0;" class="form-control-label custom-control custom-checkbox mb-0">' +
                            '<input class="dt-selectAll form-check-input custom-control-input" type="checkbox"/>' +
                            '<span class="custom-control-label"></span>' +
                        '</label>';
                    this.checkboxCol.render = (data, type, row) => {
                        return '<label class="form-control-label custom-control custom-checkbox mb-0" style="margin: 0;">' +
                                    '<input data-' + this.checkboxCol['idProperty'] + '="' +
                                    row[this.checkboxCol['idProperty']] + '"' +
                                    ' class="dt-select form-check-input custom-control-input" type="checkbox" ' +
                                    (data ? 'checked' : '') + '/><span class="custom-control-label"></span></label>';
                    }
                    this.checkboxCol.class = this.checkboxCol.class ? this.checkboxCol.class + ' excludeExport' : 'excludeExport';
                } else if (col.type == "currency") {
                    // Set a default column class for currency if one was not already set for this column
                    col.class = col.class ? col.class : "numeric";
                    // Set a default renderer for currency if one was not already set for this column
                    col.render = col.render ? col.render : $.fn.dataTable.render.number(',', '.', 2, '$');
                } else if (col.type == "date") {
                    col.render = col.render ? col.render : function (x) {
                        return moment(x).format('MMM DD, YYYY');
                    }
                } else {
					//this default is applied to prevent XSS attacks
					col.render = col.render ? col.render : $.fn.dataTable.render.text();
				}
            }
        }
    }

    replaceData(data) {
        this.dtInstance.clear();
        this.dtInstance.rows.add(data);
        this.dtInstance.draw();
        this.dtOptions.data = data;
        if (data.length < 10) {
            $('.dataTables_paginate ').hide();
        } else {
            $('.dataTables_paginate ').show();
        }
    }

    ngAfterViewInit() {
        this.datatableElement.dtInstance.then(dtInstance => {
            this.dtInstance = dtInstance;
            this.gridInit.emit(dtInstance);
            if (this.options.data.length < 10) {
                $('.dataTables_paginate ').hide();
            }
            $(".buttons-colvis .dt-down-arrow").remove(); // remove the now permanent dropdown icon
            $("div.dt-buttons").addClass("pull-right datatable-button").removeClass("dt-buttons");
            $(window).on('orientationchange', () => {
                setTimeout(() => {
                    this.dtInstance.columns.adjust().draw().responsive.recalc();
                }, 500);
            });
        });

        if (this.dtOptions.rowExpand) {
            this.bindClick('.expand-row', (event) => {
                var tr = $(event.target).closest('tr');
                if (tr.hasClass('child')) {
                    tr = tr.prev();
                }
                var row = this.dtInstance.row(tr);
                // if row expand is open (don't consider datatable default row details)
                if ( row.child.isShown() && row.child().find('ul.dtr-details').length === 0 ) {
                    // This row is already open - close it
                    row.child.hide();
                    tr.removeClass('shown');
                } else {
                    // Open this row
                    row.child( this.dtOptions.rowExpand.render(row.data()), 'p-0' ).show();
                    tr.addClass('shown');
                }
            });
        }
    }

    initCheckboxes() {
        this.bindClick('.dt-selectAll', (event) => {
            this.toggleAllCheckboxes($(event.target).is(":checked"));
            if ($(event.target).is(":checked")) {
                $('.dataTable tbody tr').addClass('selected');
            } else {
                $('.dataTable tbody tr').removeClass('selected');
            }
            this.rowsSelected.emit(this.getSelectedRows());
        })
        this.bindClick('.dt-select', (event) => {
            $(event.target).closest('tr').toggleClass('selected');
            this.toggleCheckbox($(event.target).data(this.checkboxCol['idProperty'].toLowerCase()));
            if (this.isAllSelected()) {
                $('.dt-selectAll').prop('checked', true);
            } else {
                $('.dt-selectAll').prop('checked', false);
            }
            this.rowsSelected.emit(this.getSelectedRows());
        });
    }

    toggleAllCheckboxes(newState) {
        for (let row of this.dtOptions.data) {
            row[this.checkboxCol['data']] = newState;
        }
        this.dtInstance.clear();
        this.dtInstance.rows.add(this.dtOptions.data);
        this.dtInstance.draw();
    }

    toggleCheckbox(id) {
        let row = this.findRow(id);
        row[this.checkboxCol['data']] = !row[this.checkboxCol['data']];
    }

    findRow(id) {
        return this.dtOptions.data.find(row => {
            return row[this.checkboxCol['idProperty']] == id;
        })
    }

    isAllSelected() {
        let allSelected = true;
        this.dtOptions.data.forEach(row => {
            if (!row.checked) {
                allSelected = false;
            }
        });

        return allSelected;
    }

    bindClick(className, callback) {
        $(this.datatableElement.el.nativeElement).off('click', className);
        $(this.datatableElement.el.nativeElement).on('click', className, (event) => {
            if ($(event.target).is('a')) {
                event.preventDefault();
            }
            callback(event);
        });
    }

    getSelectedRows() {
        if (this.dtOptions.data) {
            let data = this.dtOptions.data.filter((o) => {
                return this.checkboxCol && o[this.checkboxCol['data']] === true;
            });
            return data;
        } else {
            return [];
        }
    }
}
